// src/components/DeliveryPolicy.jsx
import React from 'react';
import './DeliveryPolicy.css';

const DeliveryPolicy = () => {
  return (
    <div className="delivery-policy">
      <div className="policy-card">
        <h1>📋 Delivery Policy</h1>
        <p className="subtitle">FUEL ON CALL PRIVATE LIMITED</p>

        {/* How Delivery Works */}
        <div className="policy-block">
          <h2>🚚 How Delivery Works</h2>
          <ol>
            <li><strong>Place Order</strong> - Call or order online with fuel type & quantity</li>
            <li><strong>Get Confirmation</strong> - Receive call with delivery time & driver details</li>
            <li><strong>Tanker Dispatch</strong> - Fuel tanker leaves from nearest depot</li>
            <li><strong>Live Tracking</strong> - Track delivery via WhatsApp/SMS link</li>
            <li><strong>Fuel Delivery</strong> - Trained executive delivers fuel safely</li>
            <li><strong>Payment & Bill</strong> - Digital payment & GST invoice provided</li>
          </ol>
        </div>

        {/* Safety Steps */}
        <div className="policy-block">
          <h2>🛡️ Safety Steps</h2>
          <ul>
            <li>❌ No smoking or flames within 50 meters</li>
            <li>🔌 All engines must be turned off during fuel transfer</li>
            <li>🧯 Tanker carries certified fire extinguisher</li>
            <li>⚡ Anti-static cable to prevent sparks</li>
            <li>🧤 Staff wears safety gloves, goggles & shoes</li>
            <li>🧪 Fuel quality tested before & after delivery</li>
            <li>📸 Complete delivery process recorded</li>
          </ul>
        </div>

        {/* What You Need */}
        <div className="policy-block">
          <h2>📋 What You Need</h2>
          <ul>
            <li>🚪 Clear access - Minimum 10 feet wide road</li>
            <li>📏 Parking space - 20x10 feet area for tanker</li>
            <li>👤 Authorized person (18+ years) to receive delivery</li>
            <li>📄 GST number for business billing</li>
            <li>📱 Active mobile number for OTP & updates</li>
          </ul>
        </div>

        {/* Delivery Timings */}
        <div className="policy-block">
          <h2>⏰ Delivery Timings</h2>
          <div className="timings">
            <div><strong>🌅 Morning:</strong> 6 AM - 10 AM</div>
            <div><strong>☀️ Afternoon:</strong> 10 AM - 2 PM</div>
            <div><strong>🌤️ Evening:</strong> 2 PM - 6 PM</div>
            <div><strong>🌙 Night:</strong> 6 PM - 9 PM</div>
          </div>
     
        </div>

        {/* Service Areas */}
        <div className="policy-block">
          <h2>📍 Service Areas</h2>
          <div className="cities">
            <span>Delhi NCR</span>
            <span>Gurugram</span>
            <span>Faridabad</span>
            <span>Noida</span>
            <span>Ghaziabad</span>
            <span>Jaipur</span>
          </div>
        </div>

     

   

        <div className="footer-note">
          <p>© 2024 FUEL ON CALL PRIVATE LIMITED</p>
          <p className="disclaimer">⚠️ Delivery may be cancelled if safety protocols are not followed at location</p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPolicy;